import { useEffect, useState } from "react";
import Input from "../../../components/Input/Input";
import { renderField } from "../../../utils/formUtils";
import defaultProfileImage from "../../../assets/image/profile_image.png";
import "./StudentForm.css";

const ParentProfileSection = ({
  title,
  icon,
  color = "indigo",
  imageKey,
  images,
  handleImageChange,
  changeHandler,
  onFocusHandler,
  fields,
  data,
  errors,
}) => {
  const [preview, setPreview] = useState({});
  const currentImage = images?.[imageKey];

  useEffect(() => {
    const imgObj = currentImage;

    if (imgObj?.file instanceof File) {
      const objectUrl = URL.createObjectURL(imgObj.file);
      setPreview((prev) => ({ ...prev, [imageKey]: objectUrl }));
      return () => URL.revokeObjectURL(objectUrl); // cleanup
    }

    if (imgObj?.preview) {
      setPreview((prev) => ({ ...prev, [imageKey]: imgObj.preview }));
    } else if (data?.[imageKey]) {
      setPreview((prev) => ({ ...prev, [imageKey]: data[imageKey] }));
    } else {
      setPreview((prev) => ({ ...prev, [imageKey]: defaultProfileImage }));
    }
  }, [currentImage, imageKey, data]); // ⚠️ use only the specific image object

  return (
    <div className={`card mt-3 student-form-card student-form-card-${color}`}>
      <div className="student-form-card-header">
        {icon}
        <span>{title}</span>
      </div>
      <div className="card-body row align-items-center">
        <div className="col-md-2 student-form-avatar-wrap">
          <img
            src={preview[imageKey] || defaultProfileImage}
            alt={title}
            className="student-form-avatar student-form-avatar-sm"
          />
        </div>
        <div className="col-md-10">
          <Input
            label={`${title.split(" ")[0]} Profile Pic`}
            type="file"
            name={imageKey}
            accept="image/png, image/jpeg, image/jpg"
            onChangeHandler={handleImageChange}
          />
        </div>
        {fields.map((field, idx) =>
          renderField(field, idx, handleImageChange, changeHandler, onFocusHandler, errors)
        )}
      </div>
    </div>
  );
};

export default ParentProfileSection;
